import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useUpdateItemMutation } from 'api/apiSlice';
import { markAllNotificationsRead } from '../../redux/notificationSlice';

export function useMarkAllRead() {
	const [updateItem, { isLoading, isError, error }] = useUpdateItemMutation();
	const dispatch = useDispatch();

	const markAllRead = useCallback(async () => {
		try {
			const res = await updateItem({ path: '/notifications/read_all' }).unwrap();
			dispatch(markAllNotificationsRead());
			return res;
		} catch (err) {
			console.error('Mark all as read failed:', err);
			throw err;
		}
	}, [updateItem, dispatch]);

	return {
		markAllRead,
		isMarking: isLoading,
		error,
		isError,
	};
}
